import { createContext } from 'react';

import type { UseRegisterCapsuleResult } from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/RegisterCapsuleModal/context/RegisterCapsuleModalContext.types';

/**
 * Standalone context module so bundlers never duplicate the context object
 * (which would make Provider and consumers see different instances).
 */
export const registerCapsuleModalReactContext = createContext<UseRegisterCapsuleResult | null>(
  null,
);
